export enum REPORT_STATUS {
    DONE = 'done',
    PROGRESS = 'in_progress',
    PENDING = 'pending',
}
